module.exports = __webpack_public_path__ + "static/media/download.2f02edc8.svg";